import { render, staticRenderFns } from "./physioDrugEdit.vue?vue&type=template&id=8b42a578&scoped=true"
import script from "./physioDrugEdit.vue?vue&type=script&lang=js"
export * from "./physioDrugEdit.vue?vue&type=script&lang=js"
import style0 from "./physioDrugEdit.vue?vue&type=style&index=0&id=8b42a578&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b42a578",
  null
  
)

export default component.exports